import React from 'react';
import { useHistory } from 'react-router';

// Types
import { ReviewTemplateTypeType } from 'Shared/types/ReviewTemplates.type';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useReviewTemplates } from 'Shared/utils/hooks/use-review-templates';

// Components
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import CoachingPageHeader from '../_partials/CoachingPageHeader';
import CoachingFeedbackTemplates from './CoachingFeedbackTemplates';
import GiveFeedbackOrKudosModal from 'Shared/components/GiveFeedbackOrKudosModal/GiveFeedbackOrKudosModal';
// import FeedbackTemplateSelect from 'Dashboard/components/GiveFeedbackPage/FeedbackTemplateSelect';

const CoachingFeedbackPage = () => {
  const history = useHistory();
  const { handleCreateEmptyReviewTemplate } = useReviewTemplates({
    templateType: ReviewTemplateTypeType.feedback,
  });

  const [isGiveFeedbackOrKudosModalOpen, toggleIsGiveFeedbackOrKudosModalOpen] = useToggle(false);

  const handleCreateNewTemplateClick = () => {
    handleCreateEmptyReviewTemplate().then(response => {
      history.push(PageUrlsUtil.makeCoachingFeedbackTemplateUrl({ slug: response.data.attributes.slug }));
    });
  };

  const handleGiveFeedbackClick = () => {
    toggleIsGiveFeedbackOrKudosModalOpen();
  };

  const baseClassName = 'CoachingFeedbackPage';

  return (
    <>
      <div className={baseClassName}>
        <CoachingPageHeader
          title="1:1 Feedback"
          description="Select a template to give someone feedback."
          size="lg"
          buttons={
            <WpButtonGroup>
              <WpButton variant="secondary" onClick={handleCreateNewTemplateClick}>
                Create new template
              </WpButton>
              <WpButton onClick={handleGiveFeedbackClick}>
                <WpIcon name="hand-holding-heart" />
                Give Feedback
              </WpButton>
            </WpButtonGroup>
          }
        />
        <CoachingFeedbackTemplates />
      </div>
      <GiveFeedbackOrKudosModal
        flow={'feedback'}
        isOpen={isGiveFeedbackOrKudosModalOpen}
        toggleIsOpen={toggleIsGiveFeedbackOrKudosModalOpen}
      />
    </>
  );
};

export default CoachingFeedbackPage;
